import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from '../../modelo/selectItem';

@Component({
  selector: 'bra-select',
  templateUrl: './bra-select.component.html',
  styleUrls: ['./bra-select.component.css']
})
export class BraSelectComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  placeholder: string;

  @Input() value: any;
  @Output() valueChange = new EventEmitter();
  change(newValue) {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }

  @Input()
  readonly: boolean;

  @Input()
  messageError: string;

  @Input()
  lista: SelectItem[];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-select/bra-select.component.ts